import Component from './translation/component.json';
import Term from './translation/term.json';
import Common from './translation/common.json';
import PageName from './translation/page-name.json';
import Skills from './translation/skills.json';

const lang = { Component, Term, Common, PageName, Skills };

export default lang;
